import { Trial } from '../../redux/types';

// eslint-disable-next-line import/prefer-default-export
export const checkTrialHasExpired = (trial?: Trial | null): boolean => {
  if (!trial) {
    return false;
  }
  // add full day in ms, to get next day as endDate is the midnight of the current date
  // https://stackoverflow.com/a/28981575
  const trialEndDate = new Date(trial.endDate).getTime() + 86400000;
  const currentDate = new Date().getTime();
  if (currentDate - trialEndDate > 0) {
    return true;
  }
  return false;
};

export const checkTrialHasStarted = (trial: Trial): boolean => {
  if (!trial) {
    return false;
  }

  const trialStartDate = new Date(trial.startDate).getTime();
  const currentDate = new Date().getTime();
  if (currentDate - trialStartDate > 0) {
    return true;
  }
  return false;
};

export const getAccreditedStatusId = (isAccredited: boolean): string => (isAccredited ? 'trialSetup.accredited' : 'trialSetup.notAccredited');
